import { useMemo } from 'react';
import { Divider, Text, useColorMode, VStack } from '@chakra-ui/react';

import { useCalendarSettings, useFilters, useShortcodeSettings, useLocationFilterStates } from '../../../../lib';
import { SelectFilterComponent } from './SelectFilterComponent';
import { __ } from '../../../../lib/i18n';

export const LocationFilters = () => {
	const { filters, defaultFilters } = useFilters();
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();
	const { settings: shortcodeSettings } = useShortcodeSettings();

	const { filtersTextColor, calendarBordersColor } = settings.styles[colorMode];
	const { countries, states, cities } = shortcodeSettings;

	const [showCountryFilter, showStateFilter, showCityFilter] = useMemo(
		() => [!countries && !states && !cities, !states && !cities, !cities],
		[countries, states, cities]
	);

	const { isCitiesFilterDisabled, isStatesFilterDisabled } = useLocationFilterStates();

	const stateOptions = useMemo(
		() => (isStatesFilterDisabled ? [] : defaultFilters.states),
		[isStatesFilterDisabled, defaultFilters.states]
	);

	const cityOptions = useMemo(
		() => (isCitiesFilterDisabled ? [] : defaultFilters.cities),
		[isCitiesFilterDisabled, defaultFilters.cities]
	);

	return (
		<VStack w='full' alignItems='flex-start'>
			<Text fontSize='sm' fontWeight='700' mt={2} mb='0px !important' color={filtersTextColor}>
				{__('Location')}
			</Text>
			{showCountryFilter && (
				<SelectFilterComponent
					placeholder={__('Select Country')}
					options={defaultFilters.countries}
					selectedOptions={filters.selectedCountries}
					filterKey='selectedCountries'
					color={filtersTextColor}
				/>
			)}
			{showStateFilter && (
				<SelectFilterComponent
					placeholder={__('Select State')}
					options={stateOptions}
					selectedOptions={filters.selectedStates}
					filterKey='selectedStates'
					color={filtersTextColor}
					disabled={isStatesFilterDisabled}
				/>
			)}
			{showCityFilter && (
				<SelectFilterComponent
					placeholder={__('Select City')}
					options={cityOptions}
					selectedOptions={filters.selectedCities}
					filterKey='selectedCities'
					color={filtersTextColor}
					disabled={isCitiesFilterDisabled}
				/>
			)}
			<Divider borderColor={calendarBordersColor} />
		</VStack>
	);
};
